export enum PronunciationsTableColumns {
  TEXT = 'text',
}

export enum PRONUNCIATIONS_SORT_KEYS {
  TEXT = 'TEXT',
}

export const getTableFields = (t: Function) => [
  {
    value: PronunciationsTableColumns.TEXT,
    label: t('Title'),
    sortable: true,
    sortKey: PRONUNCIATIONS_SORT_KEYS.TEXT,
    width: 850,
  },
];
